import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiHome, FiLayers, FiGrid, FiUser, FiShoppingCart } from "react-icons/fi";
import { useCart } from "../../contexts/CartContext";

const navItems = [
  { label: "Home", path: "/dashboard", icon: <FiHome size={20} /> },
  { label: "Veneers", path: "/products", icon: <FiLayers size={20} /> },
  { label: "Collections", path: "/categories", icon: <FiGrid size={20} /> },
  { label: "Cart", path: "/cart", icon: <FiShoppingCart size={20} /> },
  { label: "Account", path: "/account", icon: <FiUser size={20} /> },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cartCount } = useCart();

  // Hide on login or splash page
  if (["/", "/login"].includes(location.pathname)) return null;

  return (
    <nav style={{
      position: "fixed",
      left: 0, right: 0, bottom: 0,
      height: 72,
      background: "#ffffff",
      borderTop: "1px solid #f8f9fa",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      zIndex: 100,
      boxShadow: "0 -2px 20px rgba(0,0,0,0.08)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)"
    }}>
      {navItems.map((item) => {
        const active = location.pathname === item.path;
        return (
          <button
            key={item.label}
            onClick={() => navigate(item.path)}
            style={{
              flex: 1,
              background: "none",
              border: "none",
              outline: "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              color: active ? "#1a1a1a" : "#9ca3af",
              cursor: "pointer",
              padding: "12px 8px",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              position: "relative"
            }}
            onMouseEnter={(e) => {
              if (!active) {
                e.target.style.color = "#6b7280";
                e.target.style.transform = "translateY(-2px)";
              }
            }}
            onMouseLeave={(e) => {
              if (!active) {
                e.target.style.color = "#9ca3af";
                e.target.style.transform = "translateY(0)";
              }
            }}
          >
            <span style={{
              marginBottom: "6px",
              opacity: active ? 1 : 0.8,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              transform: active ? "scale(1.1)" : "scale(1)",
              position: "relative"
            }}>
              {item.icon}
              {item.label === "Cart" && cartCount > 0 && (
                <span style={{
                  position: "absolute",
                  top: -8,
                  right: -8,
                  background: "#333333",
                  color: "#ffffff",
                  borderRadius: "50%",
                  width: 18,
                  height: 18,
                  fontSize: 10,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid #fff"
                }}>
                  {cartCount > 99 ? "99+" : cartCount}
                </span>
              )}
            </span>
            <span style={{
              fontSize: 10,
              fontWeight: active ? 600 : 500,
              letterSpacing: 0.3,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
              {item.label}
            </span>
            {active && (
              <div style={{
                position: "absolute",
                bottom: "8px",
                width: "4px",
                height: "4px",
                background: "#1a1a1a",
                borderRadius: "50%",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
              }} />
            )}
          </button>
        );
      })}
    </nav>
  );
}
